export const translations = {
  'sv': {
    relatedContentAriaLabel: 'Relaterat innehåll',
    chatMinimizedAriaLabel: 'Chatten är minimerad',
    chatOpenedAriaLabel: 'Chatten är öppen',
    minimizeChatAriaLabel: 'Minimera chatten',
    closeChatAriaLabel: 'Stäng chatten',
    openChatAriaLabel: 'Öppna chatten',
    chatControlsAriaLabel: 'Chattkontroller',
    chatMessagesAriaLabel: 'Chattmeddelanden',
    sentMessageAriaLabel: 'Meddelande skickat',
    writeChatMessagePlaceholder: 'Skriv ett meddelande...',
    waitingForAnswerLabel: 'Väntar på svar',
    sendButtonText: 'Skicka',
    loadingText: 'Laddar...',
  },
  'en': {
    relatedContentAriaLabel: 'Related content',
    chatMinimizedAriaLabel: 'Chat is minimized',
    chatOpenedAriaLabel: 'Chat is open',
    minimizeChatAriaLabel: 'Minimize chat',
    closeChatAriaLabel: 'Close chat',
    openChatAriaLabel: 'Open chat',
    chatControlsAriaLabel: 'Chat controls',
    chatMessagesAriaLabel: 'Chat messages',
    sentMessageAriaLabel: 'Message sent',
    writeChatMessagePlaceholder: 'Type a message...',
    waitingForAnswerLabel: 'Waiting for answer',
    sendButtonText: 'Send',
    loadingText: 'Loading...',
  },
  'da': {
    relatedContentAriaLabel: 'Relateret indhold',
    chatMinimizedAriaLabel: 'Chatten er minimeret',
    chatOpenedAriaLabel: 'Chatten er åben',
    minimizeChatAriaLabel: 'Minimer chatten',
    closeChatAriaLabel: 'Luk chatten',
    openChatAriaLabel: 'Åbn chatten',
    chatControlsAriaLabel: 'Chatkontroller',
    chatMessagesAriaLabel: 'Chatbeskeder',
    sentMessageAriaLabel: 'Besked sendt',
    writeChatMessagePlaceholder: 'Skriv en besked...',
    waitingForAnswerLabel: 'Venter på svar',
    sendButtonText: 'Send',
    loadingText: 'Indlæser...',
  },
  'no': {
    relatedContentAriaLabel: 'Relatert innhold',
    chatMinimizedAriaLabel: 'Chatten er minimert',
    chatOpenedAriaLabel: 'Chatten er åpen',
    minimizeChatAriaLabel: 'Minimer chatten',
    closeChatAriaLabel: 'Lukk chatten',
    openChatAriaLabel: 'Åpne chatten',
    chatControlsAriaLabel: 'Chatkontroller',
    chatMessagesAriaLabel: 'Chatmeldinger',
    sentMessageAriaLabel: 'Melding sendt',
    writeChatMessagePlaceholder: 'Skriv en melding...',
    waitingForAnswerLabel: 'Venter på svar',
    sendButtonText: 'Send',
    loadingText: 'Laster...',
  },
  'fi': {
    relatedContentAriaLabel: 'Aiheeseen liittyvä sisältö',
    chatMinimizedAriaLabel: 'Keskustelu on pienennetty',
    chatOpenedAriaLabel: 'Keskustelu on auki',
    minimizeChatAriaLabel: 'Pienennä keskustelu',
    closeChatAriaLabel: 'Sulje keskustelu',
    openChatAriaLabel: 'Avaa keskustelu',
    chatControlsAriaLabel: 'Keskustelun hallinta',
    chatMessagesAriaLabel: 'Keskusteluviestit',
    sentMessageAriaLabel: 'Viesti lähetetty',
    writeChatMessagePlaceholder: 'Kirjoita viesti...',
    waitingForAnswerLabel: 'Odotetaan vastausta',
    sendButtonText: 'Lähetä',
    loadingText: 'Ladataan...',
  },
};